import { HttpClient } from '@angular/common/http';

import { mergeConfig, Environment } from 'src/environments/common';

declare const VERSION: string;

const initials: any = {
  developer: false,
  production: true,
  logging: false,

  version: VERSION
};

export let environment: Environment = initials;
export function fetchConfig(http: HttpClient) {
  return () => {
    return mergeConfig(http, initials).then(e => {
      environment = e;
    });
  };
}
